import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useResetPasswordRequest from '../../hooks/authentication/useResetPasswordRequest';
import './passwordReset.css';

const PasswordReset = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetPassword } = useResetPasswordRequest();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    
    // Determine if this is a password reset or initial setup
    const isPasswordReset = location.pathname.includes('reset-password');
    
    try {
      if (isPasswordReset) {
        // Use the hook's resetPassword function for password reset
        await resetPassword(token, password);
        alert('Password reset successful! Please log in with your new password.');
        navigate('/empresas/entrar');
      } else {
        // For set-password flow, use the original logic
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/set-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            token, 
            password: password,
            name, 
            phoneNumber 
          }),
        });

        if (response.ok) {
          const data = await response.json();
        
          alert('Password set successfully! Please log in with your new password.');
          navigate('/empresas/entrar');
        } else {
          const errorData = await response.json();
          setError(errorData.message); 
        }
      }
    } catch (error) {
      console.error('Error setting password:', error);
      setError('An error occurred while processing your request');
    }
  };

  // Determine if this is initial setup to show additional fields
  const isInitialSetup = !location.pathname.includes('reset-password');

  return (
    <div className='password-reset__container'>
      <h2>{isInitialSetup ? 'Crea tu contraseña' : 'Resetea tu contraseña'}</h2>
      <form onSubmit={handleSubmit} className="password-reset__form-container">
        {isInitialSetup && (
          <>
            <div className="password-reset__form-group">
              <label htmlFor="name" className="password-reset__label">Nombre:</label>
              <input 
                type="text" 
                id="name" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
              />
            </div>
            <div className="password-reset__form-group">
              <label htmlFor="phoneNumber">Número de teléfono:</label>
              <input 
                type="tel" 
                id="phoneNumber" 
                value={phoneNumber} 
                onChange={(e) => setPhoneNumber(e.target.value)} 
              />
            </div>
          </>
        )}
        <div className="password-reset__form-group">
          <label htmlFor="password">Nueva contraseña:</label>
          <div className="password-input-container">
            <input 
              type={showPassword ? "text" : "password"} 
              id="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>
        <div className="password-reset__form-group">
          <label htmlFor="confirmPassword">Confirmar contraseña:</label>
          <div className="password-input-container">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              aria-label={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {showConfirmPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" className='password-reset__submit-button'>
          {isInitialSetup ? 'Crear' : 'Resetear contraseña'}
        </button>
      </form>
    </div>
  );
};

export default PasswordReset;


